import React from 'react';
import './videos.css';
import news1 from '../../Data/Assets/images/news1.avif';
import news2 from '../../Data/Assets/images/news_2.webp';
import news3 from '../../Data/Assets/images/news3.avif';
// Thumbnails directly from YouTube
const videos = [
  {
    id: 'https://www.indiatoday.in/amp/education-today/featurephilia/story/fission-to-future-meet-young-indians-shaping-the-nuclear-story-2718043-2025-05-01',
    title: 'How Indian youth can build a career in Nuclear energy',
    thumbnail: news1,
    description:
      "From AI to forensics, India's nuclear sector opens exciting multidisciplinary career paths for students, as explained by ITER France's Nuclear Engineer Nitendra Singh.",
  },
  {
    id: 'https://www.outlookbusiness.com/in-depth/indias-nuclear-push-private-sector-steps-in-but-full-liberalisation-still-distant',
    title: 'India’s Nuclear Push: Private Sector Steps In, But Full Liberalisation Still Distant',
    thumbnail: news2,
    description:
      'The Narendra Modi-led government’s move to liberalise the sector has attracted Indian companies, including Naveen Jindal-led Jindal Nuclear Power, Tata Power and Anil Agarwal-led Vedanta.',
  },
  {
    id: 'https://www.indiatoday.in/diu/story/why-nuclear-microreactors-are-way-ahead-for-climate-friendly-electricity-in-india-2488062-2024-01-12',
    title: 'Why nuclear microreactors are way ahead for climate-friendly electricity in India',
    thumbnail: news3,
    description:
      'Microreactors are a very small form of nuclear reactors that are much safer, more portable, more scalable, and can efficiently power large areas.',
  },
];

export default function Videos() {
  return (
    <div id="videos-section">
      <div id="videos-section-title">
        <p>Latest Videos & Media</p>
      </div>

      <div id="card-row">
        {videos.map((video, idx) => (
          <div id={`card-${idx + 1}`} key={video.id}>
            <div className="card" id={`card-content-${idx + 1}`}>
              <a href={video.id} target="_blank" rel="noopener noreferrer">
                <img src={video.thumbnail} alt={video.title} id="video_img" />
              </a>
              <div className="cardLayout">
                <p class="card-title" id={`card-${idx + 1}-title`} style={{ margin: '0 0 1rem 0' }}>
                  {video.title}
                </p>
                <p
                  class="card-content"
                  id={`card-${idx + 1}-content`}
                  style={{ margin: '0 0 1rem 0' }}
                >
                  {video.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
